import styled from "styled-components";

export const DefinitionWrapper = styled.div`
  margin: 0 auto 3em;
  max-width: 1440px;
  position: relative;
  min-height: 95vh;

  @media screen and (min-width: 1024px) {
    min-height: 75vh;
  }
`;
